import { createSelector } from "reselect";
import { setCurrentUser } from "./actions/currentUser";
import { makeSelectAdminUser } from "./selectors/adminUser";
import { makeSelectCurrentUsers } from "./selectors/currentUser";
import { setAdminUser } from "./actions/adminUser";
import { setLoader } from "./actions/Loader";
import { makeSelectLoader } from "./selectors/Loader";
import {
  applyFilterToTrackable,
  clearAppliedFilterForTrackable,
} from "./actions/projectFilters";
import { makeSelectProjectFilters } from "./selectors/projectFilters";

export const actionDispatchCurrentUser = (dispatch) => ({
  setCurrentUser: (users) => dispatch(setCurrentUser(users)),
});

//   --------------------------------------------------------------------------------------
//   |   setting the redux state.                                             |
//   |  import {actionCurre...} from reduxAssets.js  &&  {useDipatch} from 'react-redux'    |
//   |  const { setCurrentUser } = actionDispatchCurrentUser(useDispatch())                 |
//   |                                                                                      |
//   ---------------------------------------------------------------------------------------

export const actionGetCurrentUser = createSelector(
  makeSelectCurrentUsers,
  (currentUser) => ({
    currentUser,
  }),
);

//   --------------------------------------------------------------------------------------
//   |  reading the redux state.                                                           |
//   |  import {actionGet...} from reduxAssets.js  &&  {useSelector} from 'react-redux'    |
//   |  const { currentUser } = useSelector(actionGetCurrentUser)                          |
//   |                                                                                     |
//   ---------------------------------------------------------------------------------------

export const actionDispatchAdminUser = (dispatch) => ({
  setAdminUser: (users) => dispatch(setAdminUser(users)),
});

//---------------------------------------------------
//   setting admin redux state
//  import {actionDispatchAdminUser..} from reduxAssets.js && {useSelector} from 'react-redux'
//  const {setAdminUser} = actionDispatchAdminUser(useDispatch())
//
//---------------------------------------------------

export const actionGetAdminUser = createSelector(
  makeSelectAdminUser,
  (adminUser) => ({
    adminUser,
  }),
);

//--------------------------------------------------------
//  getting adminUsers state
//  import {actionGetAdminUser} from reduxAssets.js && {useSelector} from 'react-redux'
//  const {adminUser} = useSelector(actionGetAdminUser)
//--------------------------------------------------------
export const actionDispatchLoader = (dispatch) => ({
  setLoader: (loaderValue) => dispatch(setLoader(loaderValue)),
});

export const actionGetLoaderValue = createSelector(
  makeSelectLoader,
  (loaderValue) => ({
    loaderValue,
  }),
);

//-----------------------------------------------------------------------------------
//  setting project filters redux state
//  import {actionDispatchProjectFilters} from reduxAssets.js && {useDispatch} from 'react-redux'
//  const { applyFilterToTrackable, clearAppliedFilterForTrackable } = actionDispatchProjectFilters(useDispatch())
//
//-----------------------------------------------------------------------------------
export const actionDispatchProjectFilters = (dispatch) => ({
  applyFilterToTrackable: (payload) => dispatch(applyFilterToTrackable(payload)),
  clearAppliedFilterForTrackable: (payload) =>
    dispatch(clearAppliedFilterForTrackable(payload)),
});

export const actionGetProjectFilters = createSelector(
  makeSelectProjectFilters,
  (projectFilters) => projectFilters,
);